import type { FC } from 'react';
import React, { memo } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import type { IconButtonAppearance } from '@atlaskit/button/new';
import { IconButton } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/core/cross';
import Tooltip from '@atlaskit/tooltip/Tooltip';

export type CloseButtonComponentProps = {
	onClose: () => void;
	label?: string;
	appearance?: IconButtonAppearance;
	isTooltipDisabled?: boolean;
	testId?: string;
	analyticsContext?: Record<string, any>;
};

const i18n = defineMessages({
	close: {
		id: 'editor-context-panel.panel-close-button.close-label',
		defaultMessage: 'Close configuration panel',
		description: 'Accessibility text for the cross button to close the config panel',
	},
});

export const CloseButton: FC<CloseButtonComponentProps> = memo(
	({
		appearance = 'subtle',
		onClose,
		label,
		isTooltipDisabled = true,
		testId = 'panel-close-button',
		analyticsContext,
	}) => {
		const { formatMessage } = useIntl();

		return (
			<Tooltip hideTooltipOnClick content={label || formatMessage(i18n.close)}>
				<IconButton
					onClick={onClose}
					appearance={appearance}
					icon={CrossIcon}
					label={label || formatMessage(i18n.close)}
					testId={testId}
					isTooltipDisabled={isTooltipDisabled}
					analyticsContext={analyticsContext}
				/>
			</Tooltip>
		);
	},
);
